import { useNavigate } from 'react-router-dom';

function AdminNav() {
    const navigate = useNavigate();
    return (
        <div>
            <button onClick={() => navigate("/bangashpanel/categories")} className='back-btn'>Categories</button>
            <button onClick={() => navigate("/bangashpanel/products")} className='back-btn'>Products</button>
            <button onClick={() => navigate("/bangashpanel/insights")} className='back-btn'>Insights</button>
            <button onClick={() => navigate("/bangashpanel/top-donators")} className='back-btn'>Top donators</button>
        </div>
    )
}

export default AdminNav